import { render } from "./InputClear.vue?vue&type=template&id=58c661c5&ts=true"
import script from "./InputClear.vue?vue&type=script&lang=ts"
export * from "./InputClear.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__